import { ImageSourcePropType } from "react-native";

export function parseRequire(file: any): ImageSourcePropType {
    if (file?.default) {
        return file.default;
    }
    return file;

}